import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

const appRoutes: Routes = [
  { path: '', redirectTo: 'ng-web', pathMatch: 'full' },
  {
    path: 'ng-web',
    component: AppComponent,
    children: [
      {
        path: 'purchase-request-form',
        loadChildren: () => import('./purchase-request-form/purchase-request-form.module').then(m => m.PurchaseRequestFormModule),
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
      },
      {
        path: 'support-chat',
        loadChildren: () => import('./support-chat-token-verification/support-chat-token-verification.module').then(m => m.SupportChatTokenVerificationModule),
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
      },
      {
        path: 'order-it',
        loadChildren: () => import('./order-it/order-it-routing.module').then(m => m.OrderItRoutingModule),
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
      },
      {
        path: 'request-it',
        loadChildren: () => import('./request-it/request-it-routing.module').then(m => m.RequestItRoutingModule),
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
      }
    ]
  },
  { path: '**', redirectTo: 'ng-web', pathMatch: 'full' }
];

@NgModule({
  declarations: [
  ],
  imports: [
    RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload' })
  ],
  exports: [
    RouterModule
  ],
  providers: [
  ]
})
export class AppRoutingModule { }

